
"use client"

import React from 'react'


import './RichText.css'

/// 改回了 nonlazy 
// http://git.qunfengshe.com/qunfengshe/bwax-app-admin/issues/541
// import RichTextComp from 'bwax-ui/auxiliary/richtext/RichText'

// for slate
import RichTextRenderer from '../auxiliary/richtext_slate/RichTextRenderer'

/**
 * @typedef { Object } RichTextProps
 * @property { Object } params
 * @property { HTMLElement|null } [scrollContainer] - 可选的 DOM 元素或 null
 * @property { string } [className]
 * @property { Function } [outlineReady]
 * @property { Object } [keywords]
 */

/**
 * @param { RichTextProps } props
 */

export default function RichText({ params, className = "", outlineReady= _ => {}, keywords = {}, scrollContainer = null }) {
    const { value } = params

    return (
        <MemoRichText value={value} className={className} outlineReady={outlineReady} keywords={keywords} scrollContainer={scrollContainer} />
    )
}

const MemoRichText = React.memo(props => {
    const { value, className, outlineReady, keywords, scrollContainer } = props

    if(!value) {
        return null
    }

    const { contentType, content, version } = resolveContentType(value);

    if(contentType === "DraftJS") {
        // return <RichTextComp value={value} />
        return "NOT SUPPORT ANY MORE"
    } else if(contentType === "Slate") {
        const slateValue = JSON.parse(content);
        return <RichTextRenderer className={className} value={slateValue} version={version} outlineReady={outlineReady} keywords={keywords}  
                scrollContainer={scrollContainer}
            />

    } else {
        return "<Unknown Rich Text Type>"
    }
   

}, (prevProps, currentProps) => {
    return prevProps.value === currentProps.value && prevProps.className == currentProps.className;
})


function resolveContentType(str) {
    /// the split the content by the first line
    const lineBreakIndex = str.indexOf('\n')
    if (lineBreakIndex === -1) {
        return ({
            contentType: "HTML",
            content: str
        })
    } else {
        const firstLine = str.substring(0, lineBreakIndex)
        let meta = null
        try {
            meta = JSON.parse(firstLine)
        } catch (e) { }

        if (meta !== null) {
            return {
                ...meta,
                content: str.substring(lineBreakIndex + 1)
            }
        } else {
            return ({
                contentType: "HTML",
                content: str
            })
        }
    }
}
